import type { Dispatch, SetStateAction } from "react";
import type { ZekayCustomer } from "../../../api/customers/Customer.typed";
import TrainingEmptyItem from "./TrainingEmptyItem";
import TrainingItem from "./TrainingItem";

type TrainingListProps = {
  customer: ZekayCustomer | undefined;
  setCustomerUpdated: Dispatch<SetStateAction<ZekayCustomer | undefined>>;
  setTrainingsOpen: Dispatch<SetStateAction<boolean>>;
  refreshCustomer: () => Promise<ZekayCustomer | undefined>;
};

export default function TrainingList(props: TrainingListProps) {
  const { customer, setCustomerUpdated, setTrainingsOpen, refreshCustomer } = props;

  const trainings = customer?.Trainings;
  if (trainings === undefined) return <TrainingEmptyItem />;
  if (!trainings.length) return <TrainingEmptyItem />;

  // Stable order so mutations (upload, status change) never reshuffle the list.
  const sortedTrainings = [...trainings].sort((a, b) => (a.ID ?? 0) - (b.ID ?? 0));

  return sortedTrainings.map((t) => (
    <TrainingItem
      key={t.ID}
      training={t}
      customer={customer}
      setCustomerUpdated={setCustomerUpdated}
      setTrainingsFormOpen={setTrainingsOpen}
      refreshCustomer={refreshCustomer}
    />
  ));
}
